/* tslint:disable */
/* eslint-disable */
/**
 * FlowInsights.Aletheia.Disciple
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios'
import { Configuration } from '../configuration'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base'
// @ts-ignore
import { ClassifierInfo } from '../modelPkg'
/**
 * TrackingApi - axios parameter creator
 * @export
 */
export const TrackingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Gets list of classifiers information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTrackingClassifiersGet: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/Tracking/classifiers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TrackingApi - functional programming interface
 * @export
 */
export const TrackingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TrackingApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Gets list of classifiers information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiTrackingClassifiersGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassifierInfo>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiTrackingClassifiersGet(options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
  }
}

/**
 * TrackingApi - factory interface
 * @export
 */
export const TrackingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = TrackingApiFp(configuration)
  return {
    /**
     *
     * @summary Gets list of classifiers information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTrackingClassifiersGet(options?: any): AxiosPromise<Array<ClassifierInfo>> {
      return localVarFp.apiTrackingClassifiersGet(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * TrackingApi - object-oriented interface
 * @export
 * @class TrackingApi
 * @extends {BaseAPI}
 */
export class TrackingApi extends BaseAPI {
  /**
   *
   * @summary Gets list of classifiers information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackingApi
   */
  public apiTrackingClassifiersGet(options?: any) {
    return TrackingApiFp(this.configuration)
      .apiTrackingClassifiersGet(options)
      .then((request) => request(this.axios, this.basePath))
  }
}
